module.exports = __webpack_public_path__ + "img/icon_package_download.d37a7b4.png";